import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { CURRENCY_OPTIONS } from '../../store/reselectors/currencies.data';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { CommonModule } from '@angular/common';
import { PrettyNumbersPipe } from 'src/app/services/pipes/prettyNumbers.pipe';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';

@Component({
    selector: 'budget-totals-strip',
    template: `
<div class="subs" *ngIf="discount || fees || tax || (subtotal && subtotal !== total)" >
  <div class="total" *ngIf="discount">
    <div class="total-title">Discount:</div>
    <div class="total-sum">({{ discount | prettyNumbers}})</div>
  </div>
  <div class="total" *ngIf="fees">
    <div class="total-title">Fees:</div>
    <div class="total-sum">{{fees | prettyNumbers}}</div>
  </div>
  <div class="total" *ngIf="subtotal && subtotal !== total">
    <div class="total-title">Subtotal:</div>
    <div class="total-sum">{{ subtotal | prettyNumbers}}</div>
  </div>
  <div class="total" *ngIf="tax">
    <div class="total-title">Tax:</div>
    <div class="total-sum">{{ tax | prettyNumbers}}</div>
  </div>
</div>
<div class="full">
  <div class="total" *ngIf="total">
    <div class="total-title">Total {{ type }}:</div>
    <div class="total-sum">{{ total | prettyNumbers }}</div>
  </div>
  <div style="flex:1;"></div>
  <div class="currency-holder">
    <div class="currency-label">Budget Currency:</div>
    <dropdown 
      [ngClass]="{ disabled: readOnly }"
      [showSearch]="true"
      [selections]="currencyOptions" 
      [disableDropdown]="readOnly"
      [selected]="currencyOptions | findById:currency" 
      [null_text]="'Select'"
      (select)="changeCurrency.emit($event.id)"
    ></dropdown>
  </div>    
</div>


`,
    styleUrls: ['./budget-totals-strip.scss'],
    standalone: true,
    imports: [DropdownComponent, FindByIdPipe, CommonModule, PrettyNumbersPipe],
})
export class BudgetTotalsStripComponent {
  @Input() discount: number
  @Input() fees: number
  @Input() subtotal: number
  @Input() tax: number
  @Input() total: number
  @Input() currency: string
  @Input() readOnly: boolean
  @Input() type: 'Revenue' | 'Costs'

  @Output() changeCurrency: EventEmitter<string> = new EventEmitter()
  currencyOptions = CURRENCY_OPTIONS
}

